/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import UpdatePlatform from './update-platform';

// TODO Mohlo by se odstranit opakování napříč různými prostředími (multi-platformní kód).
// - /util.js parsePlatform.
// - Budou asi hlavně problémy s importy.
/**
 * Utility pro práci s číselníkem platforem.
 */
class UpdatePlatformUtil {
  /**
   * Vygeneruje textovou reprezentaci platformy.
   * @param {UpdatePlatform|null} value Platforma z číselníku.
   * @returns {string|null} Platforma jako text.
   * @static
   */
  static generate(value) {
    switch (value) {
      case UpdatePlatform.KiwiLighter1:
        return 'kiwi-lighter-1';
      case UpdatePlatform.TizenSssp4:
        return 'tizen-sssp-4';
      case UpdatePlatform.Web:
        return 'web';
      case UpdatePlatform.WebosSignage3_0:
        return 'webos-signage-3.0';
      case UpdatePlatform.WebosSignage3_2:
        return 'webos-signage-3.2';
      default:
        return null;
    }
  }

  /**
   * Načte platformu z textového řetězce.
   * @param {string|null} value Platforma jako text.
   * @returns {UpdatePlatform|null} Platforma z číselníku.
   * @static
   */
  static parse(value) {
    switch (value) {
      case 'kiwi-lighter-1':
        return UpdatePlatform.KiwiLighter1;
      case 'tizen-sssp-4':
        return UpdatePlatform.TizenSssp4;
      case 'web':
        return UpdatePlatform.Web;
      case 'webos-signage-3.0':
        return UpdatePlatform.WebosSignage3_0;
      case 'webos-signage-3.2':
        return UpdatePlatform.WebosSignage3_2;
      default:
        return null;
    }
  }
}

export default UpdatePlatformUtil;
